import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'

// IndexRedirect Component
class IndexRedirect extends Component {
  render() {
    return(
        <Redirect to="/app" />
    );
  }
}
export default IndexRedirect;



// WEBPACK FOOTER //
// ./src/utils/IndexRedirect.js